import React__default from 'react';
import ChannelSettingsUI from './ChannelSettings/components/ChannelSettingsUI.js';
import { ChannelSettingsProvider } from './ChannelSettings/context.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './_rollupPluginBabelHelpers-05128ded.js';
import './index-2cfab646.js';
import './LocalizationContext-a82461b5.js';
import './stringSet-b60e9529.js';
import './index-6add7940.js';
import './ui/Icon.js';
import 'prop-types';
import './index-6420013c.js';
import './ui/Loader.js';
import './ui/IconButton.js';
import './ChannelSettings/components/ChannelProfile.js';
import './ui/ChannelAvatar.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './uuid-717930b4.js';
import './utils-7f5e872b.js';
import './ui/TextButton.js';
import './color-91e43dce.js';
import './ChannelSettings/components/EditDetailsModal.js';
import './ui/Modal.js';
import 'react-dom';
import './index-a9101009.js';
import './ui/Button.js';
import './MediaQueryContext-d6110905.js';
import './ui/Input.js';
import './ChannelSettings/components/ModerationPanel.js';
import './ui/Accordion.js';
import './ui/AccordionGroup.js';
import './context-6be2d352.js';
import './utils-e0c7329c.js';
import './ui/Badge.js';
import './ui/Toggle.js';
import './ui/ContextMenu.js';
import './ui/SortByRow.js';
import './index-579ca9d7.js';
import './utils/message/getOutgoingMessageState.js';
import './ChannelSettings/components/UserListItem.js';
import './UserProfileContext-f3f446d2.js';
import './ui/MutedAvatarOverlay.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './topics-eb548880.js';
import './ui/UserListItem.js';
import './ui/Checkbox.js';
import '@sendbird/chat/groupChannel';
import './MemberList-5d8a0a9b.js';
import './ChannelSettings/components/LeaveChannel.js';
import './ChannelSettings/components/UserPanel.js';
var ChannelSettings = function ChannelSettings(props) {
  return /*#__PURE__*/React__default.createElement(ChannelSettingsProvider, {
    overrideInviteUser: props === null || props === void 0 ? void 0 : props.overrideInviteUser,
    channelUrl: props.channelUrl,
    onCloseClick: props === null || props === void 0 ? void 0 : props.onCloseClick,
    onLeaveChannel: props === null || props === void 0 ? void 0 : props.onLeaveChannel,
    onChannelModified: props === null || props === void 0 ? void 0 : props.onChannelModified,
    onBeforeUpdateChannel: props === null || props === void 0 ? void 0 : props.onBeforeUpdateChannel,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    className: props === null || props === void 0 ? void 0 : props.className,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile
  }, /*#__PURE__*/React__default.createElement(ChannelSettingsUI, {
    renderPlaceholderError: props === null || props === void 0 ? void 0 : props.renderPlaceholderError,
    renderChannelProfile: props === null || props === void 0 ? void 0 : props.renderChannelProfile,
    renderModerationPanel: props === null || props === void 0 ? void 0 : props.renderModerationPanel,
    renderLeaveChannel: props === null || props === void 0 ? void 0 : props.renderLeaveChannel
  }));
};
export { ChannelSettings as default };